import V from "gcl";
import C from "vesh";
import Q from "querystring";

/**
 * MySQL库表转换器
 * >
 * >=
 * <
 * <=
 * =
 * !=
 * ~= in
 * !~= not in
 * @= find_in_set
 * !@= not find_in_set
 * %= like
 * !%= not like
 * && and 嵌套
 * || or 嵌套
 */
export const EMBMySQLConverter = class {
  constructor(isStrict = false) {
    const { _, __ } = pri(this, {
      opes: {},
      isStrict,
      // getValue: v => ((v ? ((v.value !== undefined && v.value !== null) ? v.value : (v || '')) : '') + '').replace(/;/g, '_'),
      getValue: (v) =>
        undefined === v || undefined === v.value
          ? undefined
          : (v.value !== null ? v.value + "" : "").replace(/;/g, "_").trim(),
      tindex: "a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u,v,w,x,y,z".split(","),
      jopes: {
        "+": "inner join",
        ">+": "left join",
        "<+": "right join",
        ",": ",",
      },
      getTable(database, table, params) {
        var opes = table.match(/[<>]?\+|\,/g);
        // console.log(
        //   44,
        //   table,
        //   Object.keys(params).length,
        //   `${database ? database + "." : ""}${table}${!!params["_as"] ? " as a " : ""}`,
        // );
        if (opes) {
          var tables = table.split(/[<>]?\+|\,/);
          if (tables.length > 26) throw new Error("连接表过多");
          if (tables.length - 1 != opes.length)
            throw new Error("连接符不匹配表数!");
          const nojoin = table.match(/\,/g);
          let options = [];
          if (!nojoin) {
            if (!params["+"]) throw new Error("缺少+参数作为on条件");
            options = eval(`[${__.getValue(params["+"])}]`)[0];
            delete params["+"];
            if (options.length != opes.length)
              throw new Error("连接条件不匹配表数!");
          } else if (params["+"]) {
            options = eval(`[${__.getValue(params["+"])}]`)[0];
            delete params["+"];
            if (options.length != opes.length)
              throw new Error("连接条件不匹配表数!");
            options.forEach(function (v) {
              for (var k in v) {
                params[k] = { value: v[k], isStandard: true };
              }
            });
          }

          let sb2 = V.sb();
          //+ jion <+ right join >+ left join
          tables.forEach(function (v, i) {
            if (i > 0) sb2.append(!nojoin ? ` ${__.jopes[opes[i - 1]]} ` : ",");
            sb2
              .append(`${database ? "." + database : ""}${v}`)
              .append(` as ${__.tindex[i]} `);
            if (!nojoin && i > 0)
              sb2.append("on ").append(_.getOpe(options[i - 1], "and"));
          });
          const ret = sb2.clear();
          sb2 = null;
          return ret;
        } else if (table.match(/\|/g)) return "{tablename}";
        else
          return `${database ? database + "." : ""}${table}${!!params["_as"] ? " as a " : ""}`;
      },
    });
    ">,>=,=,<=,<,!=,~=,!~=,@,!@,@=,!@=,%=,!%=,&&,||,+,("
      .split(",")
      .forEach((v) => (__.opes[v] = true));
  }

  getWhere(params, onlywhere = false) {
    const { __ } = pri(this);
    const paraname = {};
    for (var i in params)
      if (params[i] !== undefined && params[i].value !== undefined)
        paraname[i.toLowerCase()] = params[i];
    /**
     * 需要判断
     * _and
     * _or
     * _count
     * _order
     * _group
     * _page
     * todo or 和 and 不全 缺少对~/* /* /或者~/* /的辅助
     */
    let sb = V.sb();
    try {
      sb.append(this.getOpe(params, "and"));
      if (!V.isValid(sb.toString())) sb.append(" 1=1 ");
      if (!onlywhere) {
        if (__.getValue(paraname["_group"]))
          sb.append(` group by ${__.getValue(paraname["_group"])} `);
        if (__.getValue(paraname["_order"]))
          sb.append(` order by ${__.getValue(paraname["_order"])} `);
        if (__.getValue(paraname["_orderby"]))
          sb.append(` order by ${__.getValue(paraname["_orderby"])} `);
        if (__.getValue(paraname["_page"]))
          sb.append(
            ` limit ${__.getValue(paraname["_page"]).replace(/\s/g, "")} `,
          );
        if (__.getValue(paraname["_limit"]))
          sb.append(
            ` limit ${__.getValue(paraname["_limit"]).replace(/\s/g, "")} `,
          );
      } else if (
        onlywhere === 2 &&
        (__.getValue(paraname["_page"]) || __.getValue(paraname["_limit"]))
      )
        sb.append(
          ` limit ${parseInt(
            (
              __.getValue(paraname["_page"]) || __.getValue(paraname["_limit"])
            ).replace(/\s/g, ""),
          )} `,
        );

      return sb.clear();
    } finally {
      sb = null;
    }
  }

  /**
   * @test name (a,b)=>11
   * @test name (a,b)=>11
   * @param {*} params
   * @param {*} split
   */
  getOpe(params, split) {
    const { _, __ } = pri(this);
    let sb = V.sb();
    try {
      for (let k in params) {
        if (
          params[k] === undefined ||
          (params[k].isStandard !== undefined && params[k].value === undefined)
        ) {
          delete params[k];
          continue;
        }
        k = k.trim();
        if (
          k.startsWith("_") ||
          (!k.eq("+") && !k.eq("&&") && !k.eq("||") && !k.startsWith("$"))
        )
          continue;

        let v = __.getValue(params[k]);

        // let _v = params[k.trim("$")];
        //计算列替换
        // if (_v && (__.getValue(_v) + "").match(/[`(?"'\.\+\-*\/]/g))
        //   k = __.getValue(_v);

        // console.log(173, k, _v, __.getValue(_v));

        if (
          typeof v == "string" &&
          v.indexOf("?_NULL") >= 0 &&
          !params["_NULL"]
        ) {
          params["_NULL"] = { value: null, isStandard: true };
        }
        //有问题
        //if (!params[k.substr(1)]) params[k.substr(1)] = params[k];
        delete params[k];
        if (undefined === v) continue;
        let i = 3;
        if (
          __.opes[k] ||
          __.opes[v.toLowerCase().substr(0, i--)] ||
          __.opes[v.toLowerCase().substr(0, i--)] ||
          __.opes[v.substr(0, i--)]
        ) {
          let ope = i == 3 ? k : v.substr(0, i + 1).toLowerCase();
          // k = k.match(/[\+\-*\/]/g) ? k : k.substr(1);
          k = k.trim("$");
          switch (ope) {
            case "(":
              sb.append(` ${v} `);
              break;
            case "+":
              //为on 特别准备 如果没有删除 那么说应需要在where中出现
              let options = eval(`[${params[ope]}]`)[0];
              options.forEach(function (v, i) {
                sb.append(_.getOpe(v, "and"));
              });
              break;
            case ">":
            case ">=":
            case "<":
            case "<=":
            case "!=":
              sb.append(
                ` ${k.match(/[`?"'\.\+\-*\/\(\)]/g) ? k.trim("$") : "`" + k + "`"} ${ope}`,
              );
              //k.match(/\./) ||
              if (
                !v.startsWith("'") &&
                !v.startsWith('"') &&
                !!v.match(/\(|(\?[^,])|\+|\-|\*|\.|\/|`/)
              )
                sb.append(v.substr(ope.length));
              else if (params[k] || v.indexOf("`") >= 0)
                sb.append(
                  `${
                    v.indexOf("`") < 0
                      ? `'${v.substr(ope.length).trim('"').trim("'")}'`
                      : v.substr(ope.length)
                  }`,
                );
              else {
                k = "_" + k.replace(/\./g, "_") + V.random();
                sb.append(`?${k}`);
                params[k] = {
                  value: v.substr(ope.length).trim('"').trim("'"),
                  isStandard: true,
                };
              }
              break;
            default:
              sb.append(
                ` ${
                  k.startsWith("?") || k.indexOf(".") >= 0
                    ? "ifnull(" + k + ",'')"
                    : k.match(/[`?"'\.\+\-*\/\(\)]/g)
                      ? k
                      : "`" + k + "`"
                } `,
              );
              if ("?_NULL".eq(v)) {
                sb.append("is NULL");
              } else {
                sb.append(`${ope} ifnull(`);
                //k.match(/\./) ||
                if (
                  !v.startsWith("'") &&
                  !v.startsWith('"') &&
                  !!v.match(/\(|(\?[^,])|\+|\-|\*|\.|\/|`/)
                )
                  sb.append(v.substr(ope.length));
                else if (params[k] || v.indexOf("`") >= 0)
                  sb.append(
                    `${
                      v.indexOf("`") < 0
                        ? `'${v.substr(ope.length).trim('"').trim("'")}'`
                        : v.substr(ope.length)
                    }`,
                  );
                else {
                  k = "_" + k.replace(/\./g, "_") + V.random();
                  sb.append(`?${k}`);
                  params[k] = {
                    value: v.substr(ope.length).trim('"').trim("'"),
                    isStandard: true,
                  };
                }
                sb.append(`,'')`);
              }
              break;
            case "~=":
              //.replace(/[\(\)]/g, '')
              sb.append(
                ` ${k.match(/[`?"'\.\+\-*\/\(\)]/g) ? k : "`" + k + "`"} in (`,
              )
                .append(
                  v
                    .substr(2)
                    .split(",")
                    .map((v2) =>
                      v2.match(/[`?"'\.\+\-*\/\(\)]/g) ? v2 : `'${v2}'`,
                    )
                    .join(","),
                )
                .append(")");
              break;
            case "!~=":
              //.replace(/[\(\)]/g, '')
              sb.append(
                ` ${k.match(/[`?"'\.\+\-*\/\(\)]/g) ? k : "`" + k + "`"} not in (`,
              )
                .append(
                  v
                    .substr(3)

                    .split(",")
                    .map((v2) =>
                      v2.match(/[`?"'\.\+\-*\/\(\)]/g) ? v2 : `'${v2}'`,
                    )
                    .join(","),
                )
                .append(")");
              break;
            case "@":
              //.replace(/[\(\)]/g, '')
              sb.append(
                ` ${k.match(/[`?"'\.\+\-*\/\(\)]/g) ? k : "`" + k + "`"} between ${v
                  .trim("@")
                  .split("|")
                  .map((v2) =>
                    v2.startsWith("?") ||
                    v2.startsWith("`") ||
                    v2.startsWith("'") ||
                    v2.startsWith('"') ||
                    v2.indexOf(".") >= 0
                      ? v2
                      : `'${v2}'`,
                  )
                  .join(" and ")} `,
              );
              break;
            case "!@":
              //.replace(/[\(\)]/g, '')
              sb.append(
                ` ${
                  k.match(/[`?"'\.\+\-*\/\(\)]/g) ? k : "`" + k + "`"
                } not between ${v
                  .substr(2)

                  .split("|")
                  .map((v2) =>
                    v2.startsWith("?") ||
                    v2.startsWith("`") ||
                    v2.startsWith("'") ||
                    v2.startsWith('"') ||
                    v2.indexOf(".") >= 0
                      ? v2
                      : `'${v2}'`,
                  )
                  .join(" and ")} `,
              );
              break;
            case "@=":
              sb.append(
                ` find_in_set(${
                  (v.endWith("`") ? "" : '"') +
                  v.substr(2).replace(/['"]/g, '"') +
                  (v.endWith("`") ? "" : '"')
                },${k.match(/[`?"'\.\+\-*\/\(\)]/g) ? k : "`" + k + "`"})>0`,
              );
              break;
            case "!@=":
              sb.append(
                ` find_in_set(${
                  (v.endWith("`") ? "" : '"') +
                  v.substr(3).replace(/['"]/g, '"') +
                  (v.endWith("`") ? "" : '"')
                },${k.match(/[`?"'\.\+\-*\/\(\)]/g) ? k : "`" + k + "`"})<=0`,
              );
              break;
            case "%=":
              sb.append(
                ` ${
                  k.match(/[`?"'\.\+\-*\/\(\)]/g) ? k : "`" + k + "`"
                } like concat('%','${v
                  .substr(2)
                  .trim("'")
                  .trim('"')
                  .replace(/'/g, "\\'")}','%')`,
              );
              break;
            case "!%=":
              sb.append(
                ` ${
                  k.match(/[`?"'\.\+\-*\/\(\)]/g) ? k : "`" + k + "`"
                } not like concat('%','${v
                  .substr(3)
                  .trim("'")
                  .trim('"')
                  .replace(/'/g, "\\'")}','%')`,
              );
              break;
            case "&&":
              {
                // console.log(389, "&&", v);
                let opes = eval(`[${v.trim()}]`)[0];
                if (!V.isArray(opes)) opes = [opes];
                sb.append(" (");
                opes.forEach(function (v, i) {
                  sb.append(_.getOpe(v, "and"));
                  for (let k2 in v) {
                    if (k2.startsWith("_")) params[k2] = v[k2];
                    //参数设定补偿
                  }
                  if (i < opes.length - 1) sb.append(" and ");
                });
                sb.append(" )");
                //保证适配性更好
              }
              break;
            case "||":
              {
                // console.log(389, "&&", v);
                let opes = eval(`[${v.trim()}]`)[0];
                if (!V.isArray(opes)) opes = [opes];
                sb.append(" (");
                opes.forEach(function (v, i) {
                  sb.append(_.getOpe(v, "or"));
                  for (let k2 in v) {
                    if (k2.startsWith("_")) params[k2] = v[k2];
                    //参数设定补偿
                  }
                  if (i < opes.length - 1) sb.append(" or ");
                });
                sb.append(" )");
                //保证适配性更好
              }
              break;
          }
        } else {
          // k = k.substr(1);
          k = k.trim("$");
          sb.append(
            ` ${
              k.startsWith("?") || k.indexOf(".") >= 0
                ? "ifnull(" + k + ",'')"
                : k.match(/[`?"'\.\+\-*\/\(\)]/g)
                  ? k
                  : "`" + k + "`"
            } `,
          );

          if ("?_NULL".eq(v)) {
            sb.append(" is NULL");
          } else {
            sb.append("= ifnull(");
            //k.match(/\./) ||
            if (
              !v.startsWith("'") &&
              !v.startsWith('"') &&
              !!v.match(/\(|(\?[^,])|\+|\-|\*|\.|\/|`/)
            )
              sb.append(v);
            else if (params[k] || v.indexOf("`") >= 0)
              sb.append(v.indexOf("`") < 0 ? `'${v.trim("'").trim('"')}'` : v);
            else {
              k = "_" + k.replace(/[\.\?\$\(\)]/g, "_") + V.random();
              sb.append(`?${k}`);
              params[k] = { value: v.trim('"').trim("'"), isStandard: true };
            }
            sb.append(",'')");
          }
        }
        sb.append(` ${split} `);
      }
      return sb.clear().trim(` ${split} `);
    } finally {
      sb = null;
    }
  }

  lstParams(params, func, split = ",") {
    let sb = V.sb();
    try {
      for (let k in params) {
        let v = params[k];
        !k.startsWith("_") &&
          !k.startsWith("$") &&
          k.indexOf(";") < 0 &&
          typeof v != "function" &&
          sb.append(func(k, v)).append(split);
      }
      return sb.clear().trim(split);
    } finally {
      sb = null;
    }
  }

  convert(cmd) {
    const { _, __ } = pri(this);
    var that = this;
    let command = cmd.command || "",
      params = cmd.params,
      paraname = {};
    for (var i in params) {
      //防止注入
      if (!!i.match(/;/)) delete params[i];
      else paraname[i.toLowerCase()] = params[i];
    }
    const cmds = command.replace(/[\\\/]/g, ".").split(".");
    let sb = V.sb();
    //const ID = params._ID || params._IID; //_IID:自增AutoIncrease ID
    try {
      switch (cmds.length) {
        case 4:
          {
            /**
             * id 主键
             * column 修改表
             * index 索引
             * add
             * drop
             */
            const database = cmds[0].replace(/^[~_\.]$/, ""),
              table = cmds[1],
              obj = cmds[2].toLowerCase(),
              method = cmds[3];
            switch (method.toLowerCase()) {
              case "drop":
                database.length && sb.append(`use ${database};`);
                sb.append(`alter table ${table} `);
                if (obj.eq("index")) {
                  let names = [];
                  for (var k in params)
                    if (!k.startsWith("$") && !k.startsWith("_"))
                      names.push(k.toLowerCase());
                  names.sort();
                  sb.append(
                    ` drop ${obj} IX_${V.hash(names.join(","))}`,
                  ).append(";select 1 as count;");
                  names = null;
                } else if (obj.eq("id")) {
                  sb.append(` drop primary key;select 1 as count;`);
                } else if (obj.eq("part")) {
                  sb.append(
                    that.lstParams(
                      params,
                      (k, v) => ` drop PARTITION \`${k}\``,
                    ),
                  ).append(";select 1 as count;");
                } else
                  sb.append(
                    that.lstParams(params, (k, v) => ` drop ${obj} \`${k}\``),
                  ).append(";select 1 as count;");
                break;
              case "change":
                database.length && sb.append(`use ${database};`);
                if (obj.eq("index")) {
                  let names = [];
                  for (var k in params)
                    if (!k.startsWith("$") && !k.startsWith("_"))
                      names.push(k.toLowerCase());
                  names.sort();
                  sb.append(`alter table ${table} drop index `)
                    .append("IX_" + V.hash(names.join(",")))
                    .append(
                      `;alter table ${table} add ${
                        params["_unique"] ? "UNIQUE" : ""
                      } ${obj} `,
                    )
                    .append("IX_" + V.hash(names.join(",")))
                    .append("(")
                    .append(
                      that.lstParams(
                        params,
                        (k, v) => `${k} ${__.getValue(v) || "ASC"}`,
                      ),
                    )
                    .append(");select 1 as count;");
                  names = null;
                } else if (obj.eq("id")) {
                  if (!__.getValue(paraname["_id"]))
                    throw new Error("请输入_ID参数");
                  sb.append(
                    `alter table ${table} drop primary key,add PRIMARY KEY(${__.getValue(
                      paraname["_id"],
                    ).replace(/\+/g, ",")});`,
                  ).append(`select 1 as count;`);
                } else if (obj.eq("part")) {
                  //(' REORGANIZE PARTITION (');
                  //todo 过于复杂暂时中止
                } else
                  sb.append(`alter table ${table} `)
                    .append(
                      that.lstParams(
                        params,
                        (k, v) => ` change \`${k}\` \`${k}\` ${__.getValue(v)}`,
                      ),
                    )
                    .append(";select 1 as count;");
                break;
              case "add":
                database.length && sb.append(`use ${database};`);
                sb.append(`alter table ${table}`);
                if (obj.eq("index")) {
                  let names = [];
                  for (var k in params)
                    if (!k.startsWith("$") && !k.startsWith("_"))
                      names.push(k.toLowerCase());
                  names.sort();
                  sb.append(
                    ` add ${
                      params["_unique"] ? "UNIQUE" : ""
                    } ${obj} IX_${V.hash(names.join(","))}`,
                  )
                    .append("(")
                    .append(
                      that.lstParams(
                        params,
                        (k, v) => `${k} ${__.getValue(v) || "ASC"}`,
                      ),
                    )
                    .append(");select 1 as count;");
                  names = null;
                } else if (obj.eq("id")) {
                  if (!__.getValue(paraname["_id"]))
                    throw new Error("请输入_ID参数");
                  sb.append(
                    ` add PRIMARY KEY(${__.getValue(paraname["_id"]).replace(
                      /\+/g,
                      ",",
                    )});`,
                  ).append(`select 1 as count;`);
                } else if (obj.eq("part")) {
                  sb.append(" ADD PARTITION (");
                  if (V.isValid(paraname["range"])) {
                    let parts = __.getValue(paraname["range"]).split(/[;,]/g);
                    let index = parseInt(__.getValue(paraname["index"])) || 0;
                    sb.append(
                      parts
                        .map(
                          (v, i) =>
                            `PARTITION P${index + i} VALUES LESS THAN (${v})`,
                        )
                        .join(","),
                    );
                  } else if (V.isValid(paraname["list"])) {
                    let parts = __.getValue(paraname["list"]).split(/[;,]/g);
                    let index = parseInt(__.getValue(paraname["index"])) || 0;
                    sb.append(
                      parts
                        .map(
                          (v, i) => `PARTITION P${index + i} VALUES IN (${v})`,
                        )
                        .join(","),
                    );
                  }
                  sb.append(");select 1 as count;");
                } else
                  sb.append(
                    that.lstParams(
                      params,
                      (k, v) =>
                        ` add ${obj} \`${k}\` ${
                          __.getValue(v) || "VARCHAR(32)"
                        }`,
                    ),
                  ).append(";select 1 as count;");
                break;
              default:
                throw new Error("未识别的命令" + command);
            }
          }
          break;
        case 3:
          /**
           * 库名/表名/操作
           * create 建表
           * drop 删除表
           * add 增加数据
           * del 删除数据
           * update 修改数据? 同名字段
           * select 查询数据
           * count 查询数据
           * sum 查询数据
           * edit 指明select,count,sum之外的操作
           * truncate
           * //todo replace
           */
          {
            const database = cmds[0].replace(/^[~_\.]$/, ""),
              table = cmds[1],
              method = cmds[2];
            switch (method.toLowerCase()) {
              case "createview":
                database.length && sb.append(`use ${database};`);
                sb.append(
                  `CREATE VIEW ${table} as ${
                    __.getValue(paraname["_sql"]) || ""
                  };select 1 as count;`,
                );
                break;
              case "dropview":
                database.length && sb.append(`use ${database};`);
                sb.append(`Drop VIEW ${table};select 1 as count;`);
                break;
              case "create":
                database.length && sb.append(`use ${database};`);
                sb.append(`create table if not exists ${table}(`).append(
                  that.lstParams(
                    params,
                    (k, v) => `${k} ${__.getValue(v) || "VARCHAR(32)"}`,
                  ),
                );
                if (V.isValid(paraname["_id"]))
                  sb.append(
                    `,PRIMARY KEY(${__.getValue(paraname["_id"]).replace(
                      /\+/g,
                      ",",
                    )})`,
                  );
                if (V.isValid(paraname["_index"]))
                  __.getValue(paraname["_index"])
                    .split(",")
                    .map((v) =>
                      sb.append(
                        `,INDEX IX_${V.hash(v)}(${v.replace(/\+/g, ",")})`,
                      ),
                    );
                sb.append(
                  ") ENGINE = INNODB CHARACTER SET utf8 COLLATE utf8_general_ci",
                );
                let subpart = "";
                if (V.isValid(paraname["_subpart"])) {
                  //_subpart:list:asbd,1,2,34;5,6,7
                  //_subpart:hash:abcd,2
                  let _subpart = V.sb();
                  let parts = __.getValue(paraname["_subpart"]).split(":");
                  const type = parts.shift().toLowerCase().trim();
                  if (parts.length)
                    switch (type) {
                      case "list":
                        parts = parts[0].split(";");
                        _subpart
                          .append(
                            ` SUBPARTITION BY LIST ${type}SUBPARTITION TEMPLATE(`,
                          )
                          .append(
                            parts
                              .map(
                                (v, i) =>
                                  `SUBPARTITION P${i} VALUES (${v
                                    .split(",")
                                    .map((v2) =>
                                      Number.isInteger(v2)
                                        ? v2
                                        : `'${v2.trim('"').trim("'")}`,
                                    )
                                    .join(",")})`,
                              )
                              .join(","),
                          )
                          .append(")");
                        break;
                      case "hash":
                        parts = parts[0].split(/[;,]/g);
                        _subpart.append(
                          ` SUBPARTITION BY ${type} (${parts.shift()}) subpartitions ${parts.shift()}`,
                        );
                        break;
                    }
                  subpart = _subpart.clear();
                  _subpart = null;
                }
                if (V.isValid(paraname["_part"])) {
                  let parts = __.getValue(paraname["_part"]).split(":");
                  const type = parts.shift().toLowerCase().trim();
                  if (parts.length)
                    switch (type) {
                      case "range":
                        parts = parts[0].split(/[;,]/g);
                        sb.append(
                          ` partition BY RANGE (${parts.shift()}) ${subpart}{`,
                        )
                          .append(
                            parts
                              .map(
                                (v, i) =>
                                  `PARTITION P${i} VALUES LESS THAN (${v})`,
                              )
                              .join(","),
                          )
                          .append("}");
                        break;
                      case "list":
                        parts = parts[0].split(";");
                        sb.append(
                          ` partition BY LIST (${parts.shift()}) ${subpart}{`,
                        )
                          .append(
                            parts
                              .map((v, i) => `PARTITION P${i} VALUES IN (${v})`)
                              .join(","),
                          )
                          .append("}");
                        break;
                      case "hash":
                      case "key":
                      case "linear hash":
                        parts = parts[0].split(/[;,]/g);
                        sb.append(
                          ` partition BY ${type} (${parts.shift()}) ${subpart} `,
                        ).append(` PARTITIONS ${parts[0] || 1}`);
                        break;
                      case "range columns":
                        parts = parts[0].split(/[;,]/g);
                        sb.append(
                          ` partition BY ${type} (${parts.shift()}) ${subpart} {`,
                        )
                          .append(
                            parts
                              .map(
                                (v, i) =>
                                  ` PARTITION P${i} VALUES LESS THAN (${
                                    Number.isInteger(v)
                                      ? v
                                      : `'${v.trim('"').trim("'")}'`
                                  })`,
                              )
                              .join(","),
                          )
                          .append("}");
                        break;
                      case "list columns":
                        parts = parts[0].split(/[;,]/g);
                        sb.append(` partition BY ${type} (${parts.shift()}) {`)
                          .append(
                            parts
                              .map(
                                (v, i) =>
                                  ` PARTITION P${i} VALUES IN (${v
                                    .split(",")
                                    .map((v2) =>
                                      Number.isInteger(v2)
                                        ? v2
                                        : `'${v2.trim('"').trim("'")}'`,
                                    )
                                    .join(",")})`,
                              )
                              .join(","),
                          )
                          .append("}");
                        break;
                    }
                }
                sb.append(";select 1 as count;");
                break;
              case "drop":
                database.length && sb.append(`use ${database};`);
                sb.append(`drop table ${table};select 1 as count;`);
                break;
              case "replace":
              case "add":
                //insert into a (a,b,c) values (?a,?b,?c);select @@IDentity as ID,row_count as count;
                sb.append(3 == method.length ? "insert" : "replace");
                sb.append(
                  ` into ${database.length ? database + "." : ""}${table} (`,
                );
                sb.append(that.lstParams(params, (k, v) => `\`${k}\``)).append(
                  ")  values (",
                );
                sb.append(
                  that.lstParams(params, (k, v) => {
                    var val =
                      v && v.value === null ? "_NULL" : __.getValue(v) || "";

                    if (val.indexOf("?_GUID") >= 0)
                      params["_GUID"] = {
                        type: "varchar",
                        isStandard: true,
                        value: V.GUID(),
                      };

                    if ("?_SNOWID".eq(val))
                      params["_SNOWID"] = {
                        type: "varchar",
                        isStandard: true,
                        value: V.SNOWID(),
                      };

                    if (val.indexOf("?_NULL") >= 0 || "_NULL".eq(val)) {
                      params["_NULL"] = {
                        type: "varchar",
                        isStandard: true,
                        value: null,
                      };
                      return "null";
                    }
                    if (
                      !val.startsWith("'") &&
                      !val.startsWith('"') &&
                      !!val.match(/\(|(\?[^,])|\+|\-|\*|\.|\/|`/)
                    )
                      return val;
                    else {
                      v.value = val.trim('"').trim("'");
                      return `?${k}`;
                    }
                  }),
                ).append(
                  `);select @@IDentity as ID,row_count() as count${
                    params["_GUID"]
                      ? ',"' + params["_GUID"].value + '" as GUID'
                      : ""
                  }${
                    params["_SNOWID"]
                      ? ',"' + params["_SNOWID"].value + '" as SNOWID'
                      : ""
                  };`,
                );
                break;
              case "del":
                //delete from a where a=1 and b=2 and c=4 and (a=1 or b=2);select row_count() as count;
                {
                  sb.append("delete ");
                  if (table.match(/[<>]?\+|\,/g)) {
                    var delindex = __.tindex
                      .map(function (v) {
                        return !!params[v] ? v : null;
                      })
                      .filter(function (v) {
                        return !!v;
                      })
                      .join(",");
                    if (!delindex)
                      throw new Error("表连接未能说明需要删除的表 譬如a:true");
                    sb.append(delindex);
                  }
                  sb.append(
                    ` from ${__.getTable(database, table, params)} where `,
                  );
                  const where = that.getWhere(params, true);
                  if (where.trim().eq("1=1"))
                    throw new Error("不能无条件删除所有数据!");
                  sb.append(where).append(`;select row_count() as count;`);
                }
                break;
              case "truncate":
                //delete from a where a=1 and b=2 and c=4 and (a=1 or b=2);select row_count() as count;
                {
                  // const where = that.getWhere(params, true);
                  // if (where.trim().eq("1=1"))
                  //   throw new Error("不能无条件删除所有数据!");
                  sb.append(
                    `truncate table ${
                      database.length ? database + "." : ""
                    }${table} ;select row_count() as count;`,
                  );
                }
                break;
              case "update":
                {
                  sb.append(
                    `update ${__.getTable(
                      database,
                      table.replace(/[<>]?\+/g, ","),
                      params,
                    )} set `,
                  );
                  var sbset = V.sb();
                  for (let k in params) {
                    k = k.replace(/;/g, "_");
                    let v = __.getValue(params[k]);
                    if (undefined === v) continue;
                    if (
                      !k.startsWith("_") &&
                      !k.startsWith("$") &&
                      !k.startsWith("&&") &&
                      !k.startsWith("||")
                    )
                      sbset
                        .append(
                          (k.match(/\./) ? k : `\`${k}\``) +
                            ` = ${
                              !v.startsWith("'") &&
                              !v.startsWith('"') &&
                              !!v.match(/\(|(\?[^,])|\+|\-|\*|\.|\/|`/)
                                ? "?_null".eq(v)
                                  ? "null"
                                  : v
                                : v.startsWith("_")
                                  ? (function () {
                                      switch (v.toLowerCase()) {
                                        case "_increase":
                                          return "ifnull(" + k + ",0)+1";
                                        case "_decrease":
                                          return (
                                            "greatest(0,ifnull(" + k + ",0)-1)"
                                          );
                                        case "_null":
                                          return "null";
                                        default:
                                          return "?" + k;
                                      }
                                    })()
                                  : (function () {
                                      params[k].value = v.trim('"').trim("'");
                                      if (k.match(/\./)) {
                                        var nk =
                                          k.replace(/\./g, "_") + V.random();
                                        params[nk] = params[k];
                                        delete params[k];
                                        k = nk;
                                      }
                                      return "?" + k;
                                    })()
                            }`,
                        )
                        .append(",");
                  }
                  sb.append(sbset.clear().trim(","))
                    .append(" where ")
                    .append(that.getWhere(params, true))
                    .append(`;select row_count() as count;`);
                  sbset = null;
                }
                break;
              case "select":
                {
                  //保证两次返回的值一定
                  const params2 = V.merge({}, params);
                  sb.append(
                    `select ${
                      V.isValid(__.getValue(params["_distinct"]))
                        ? "distinct "
                        : ""
                    }`,
                  );
                  const length = sb.toString().length;
                  if (V.isValid(__.getValue(params["_columns"]))) {
                    //对columns进行特殊处理
                    var columns = __.getValue(params["_columns"]);
                    delete params["_columns"];
                    columns.split(",").forEach(
                      (col) =>
                        (params[col.replace(/^[$_?]|\s/g, "")] = {
                          value: true,
                        }),
                    );
                  }
                  for (let k in params) {
                    if (
                      !k.startsWith("_") &&
                      !k.startsWith("+") &&
                      !k.startsWith("$") &&
                      !k.startsWith("&&") &&
                      !k.startsWith("||")
                    ) {
                      const v = __.getValue(params[k]);
                      if (undefined === v) continue;
                      k = k.replace(/;/g, "_");
                      if (!!v.match(/[\.\?\(\)\+\-\*/]/))
                        sb.append(`${v} as \`${k}\``).append(",");
                      else if (k.match(/\./g))
                        sb.append(k)
                          .append((v + "").eq("true") ? "" : ` as ${v} `)
                          .append(",");
                      else
                        sb.append(`\`${k}\``)
                          .append((v + "").eq("true") ? "" : ` as ${v} `)
                          .append(",");
                    }
                  }
                  if (length == sb.toString().length) {
                    if (__.isStrict) throw new Error("不能显示所有列");
                    else sb.append("*");
                  } else sb.append(sb.clear().trim(","));
                  params["_lock"] &&
                    sb.append(
                      ` ${
                        true === params["_lock"]
                          ? "for update"
                          : params["_lock"]
                      } `,
                    );
                  const body = ` from ${__.getTable(database, table, params)} `;
                  sb.append(body)
                    .append(`where ${that.getWhere(params)}`)
                    .append(";");
                  params["_count"] &&
                    sb
                      .append(
                        `select count(${
                          V.isValid(__.getValue(params["_distinct"]))
                            ? "distinct "
                            : ""
                        }*) as count ${body} where `,
                      )
                      .append(that.getWhere(params2, true))
                      .append(";");
                  V.merge(params, params2, true);
                  if (table.match(/[\|&]/g)) {
                    //| union & union all
                    const sql = sb.clear().trim(";");
                    const ope = table.match(/\|/g) ? "|" : "&";
                    sb.append(
                      table
                        .split(ope)
                        .map(function (v) {
                          return sql.replace(/\{tablename\}/g, v);
                        })
                        .join(ope.eq("|") ? " union " : " union all ") + ";",
                    );
                  }
                }
                break;
              case "count":
                {
                  sb.append(`select `).append(
                    (paraname["_group"]
                      ? __.getValue(paraname["_group"]) + ","
                      : "") || "",
                  );
                  const length = sb.toString().length;

                  var i = 1;
                  for (let k in params) {
                    if (
                      !k.startsWith("_") &&
                      !k.startsWith("$") &&
                      !k.startsWith("&&") &&
                      !k.startsWith("||")
                    )
                      sb.append(
                        `count(${
                          V.isValid(__.getValue(params["_distinct"]))
                            ? "distinct "
                            : ""
                        }`,
                      )
                        .append(
                          k.match(/[\.,\(]/g)
                            ? k
                            : (__.getValue(params[k]) + "").match(/[\.\(,]/g)
                              ? __.getValue(params[k])
                              : `\`${k}\``,
                        )
                        .append(`) as ${k.match(/\./g) ? "count" + i++ : k},`);
                  }

                  if (length == sb.toString().length)
                    throw new Error("count命令未设置统计列 例如 column1:true");
                  else sb.append(sb.clear().trim(","));

                  const body = __.getTable(database, table, params);
                  const where = that.getWhere(params);
                  sb.append(` from ${body} where `).append(where).append(";");
                  params["_count"] &&
                    sb.append(
                      `select count(*) as count from (${sb
                        .toString()
                        .trim(";")}) a;`,
                    );
                  //todo 优化SQL
                }
                break;
              case "sum":
                {
                  sb.append(`select `).append(
                    (paraname["_group"]
                      ? __.getValue(paraname["_group"]) + ","
                      : "") || "",
                  );
                  const length = sb.toString().length;
                  var i = 1;
                  for (let k in params) {
                    if (
                      !k.startsWith("_") &&
                      !k.startsWith("$") &&
                      !k.startsWith("&&") &&
                      !k.startsWith("||")
                    )
                      sb.append(
                        `sum(${
                          V.isValid(__.getValue(params["_distinct"]))
                            ? "distinct "
                            : ""
                        }`,
                      )
                        .append(
                          k.match(/[\.,\(]/g)
                            ? k
                            : (__.getValue(params[k]) + "").match(/[\.\(,]/g)
                              ? __.getValue(params[k])
                              : `\`${k}\``,
                        )
                        .append(`) as ${k.match(/\./g) ? "count" + i++ : k},`);
                  }
                  if (length == sb.toString().length)
                    throw new Error("sum命令未设置统计列 例如 column1:true");
                  else sb.append(sb.clear().trim(","));

                  const body = __.getTable(database, table, params);
                  const where = that.getWhere(params);
                  sb.append(` from ${body} where `).append(where).append(";");
                  params["_count"] &&
                    sb.append(
                      `select count(*) as count from (${sb
                        .toString()
                        .trim(";")}) a;`,
                    );
                  //todo 优化SQL
                }
                break;
              case "updateevent":
                {
                  var sbset = V.sb();
                  for (let k in params) {
                    let v = __.getValue(params[k]);
                    if (undefined === v) continue;
                    if (
                      !k.startsWith("_") &&
                      !k.startsWith("$") &&
                      !k.startsWith("&&") &&
                      !k.startsWith("||")
                    )
                      sbset
                        .append(
                          (k.match(/\./) ? k : `\`${k}\``) +
                            ` = ${
                              !v.startsWith("'") &&
                              !v.startsWith('"') &&
                              !!v.match(/\(|(\?[^,])|\+|\-|\*|\.|\/|`/)
                                ? v
                                : v.startsWith("_")
                                  ? (function () {
                                      switch (v.toLowerCase()) {
                                        case "_increase":
                                          return "ifnull(" + k + ",0)+1";
                                        case "_decrease":
                                          return (
                                            "greatest(0,ifnull(" + k + ",0)-1)"
                                          );
                                        case "_null":
                                          return "null";
                                        default:
                                          return "?" + k;
                                      }
                                    })()
                                  : (function () {
                                      params[k].value = v.trim('"').trim("'");
                                      if (k.match(/\./)) {
                                        var nk =
                                          k.replace(/\./g, "_") + V.random();
                                        params[nk] = params[k];
                                        delete params[k];
                                        k = nk;
                                      }
                                      return "?" + k;
                                    })()
                            }`,
                        )
                        .append(",");
                  }
                  let _table = __.getTable(
                    database,
                    table.replace(/[<>]?\+/g, ","),
                    params,
                  );
                  // set session group_concat_max_len=102400000;//默认长度是1024
                  // select group_concat('\'',ID,'\'') into @ID from ff_schedulehis where  `ID` = ifnull(?_ID,'');
                  // set @ID = ifnull(@ID,'NULL');//当执行group_concat后,如果没有查到值，@ID会变为null，此时不能直接拼接到 in()里面
                  // SET @sql=concat('select * from ff_schedulehis  where ID in (',@ID,');');
                  // prepare co FROM @sql;execute co;SET @sql2=concat("update ff_schedulehis set `sn` = ?sn where ID in (",@ID,");");prepare co1 FROM @sql2;execute co1;select row_count() as count;execute co;DEALLOCATE PREPARE co;DEALLOCATE PREPARE co1;
                  //预编译命令prepare 后面只能接一个sql;
                  //执行预编译sql 后，记得DEALLOCATE PREPARE co1 (释放资源)
                  sb.append("set session group_concat_max_len=102400000;");
                  sb.append(
                    "select group_concat('\\'',ID,'\\'') into @ID from (select ID from ",
                  )
                    .append(_table)
                    .append(" where ")
                    .append(that.getWhere(params, 2));
                  sb.append(
                    " ) a;set @ID = ifnull(@ID,'NULL');SET @sql=concat('select * from ",
                  )
                    .append(_table)
                    .append(
                      "  where ID in (',@ID,');');prepare co FROM @sql;execute co;",
                    );
                  sb.append('SET @sql2=concat("update ')
                    .append(_table)
                    .append(" set ")
                    .append(sbset.clear().trim(","))
                    .append(
                      ' where ID in (",@ID,");");prepare co1 FROM @sql2;execute co1;select row_count() as count;execute co;DEALLOCATE PREPARE co;DEALLOCATE PREPARE co1;',
                    );
                  sbset = null;
                  //console.log('sql', sb.toString());
                }
                break;
              case "replaceevent":
              case "addevent":
                //insert into a (a,b,c) values (?a,?b,?c);select @@IDentity as ID,row_count as count;
                //set @count=row_count();set @ID=CASE WHEN @@IDentity THEN @@IDentity ELSE _GUID的值 END;select @@IDentity as ID,@count as count [,_GUID as GUID]
                //;select * from 表 where @count>0 and ID=@ID;
                {
                  let _table = __.getTable(
                    database,
                    table.replace(/[<>]?\+/g, ","),
                    params,
                  );
                  sb.append(
                    8 == method.length()
                      ? "insert"
                      : `select * from ${_table} where ID=@ID;replace`,
                  );
                  sb.append(" into ").append(_table).append("(");
                  sb.append(
                    that.lstParams(params, (k, v) => `\`${k}\``),
                  ).append(")  values (");
                  sb.append(
                    that.lstParams(params, (k, v) => {
                      var val =
                        v && v.value === null ? "_NULL" : __.getValue(v) || "";

                      if (val.indexOf("?_GUID") >= 0)
                        params["_GUID"] = {
                          type: "varchar",
                          isStandard: true,
                          value: V.GUID(),
                        };

                      if (val.indexOf("?_SNOWID") >= 0)
                        params["_SNOWID"] = {
                          type: "varchar",
                          isStandard: true,
                          value: V.SNOWID(),
                        };

                      if (val.indexOf("?_NULL") >= 0 || "_NULL".eq(val)) {
                        params["_NULL"] = {
                          type: "varchar",
                          isStandard: true,
                          value: null,
                        };
                        return "null";
                      }
                      if (
                        !val.startsWith("'") &&
                        !val.startsWith('"') &&
                        !!val.match(/\(|(\?[^,])|\+|\-|\*|\.|\/|`/)
                      )
                        return val;
                      else {
                        v.value = val.trim('"').trim("'");
                        return `?${k}`;
                      }
                    }),
                  )
                    .append(
                      ");set @count=row_count();set @ID=CASE WHEN @@IDentity THEN @@IDentity ELSE ",
                    )
                    .append(
                      params["_GUID"]
                        ? '"' + params["_GUID"].value + '"'
                        : "NULL",
                    )
                    .append(
                      params["_SNOWID"]
                        ? '"' + params["_SNOWID"].value + '"'
                        : "NULL",
                    )
                    .append(" END;select @ID as ID,@count as count")
                    .append(
                      params["_GUID"]
                        ? ',"' + params["_GUID"].value + '" as GUID'
                        : "",
                    )
                    .append(
                      params["_SNOWID"]
                        ? ',"' + params["_SNOWID"].value + '" as SNOWID'
                        : "",
                    );
                  sb.append(";select * from ")
                    .append(_table)
                    .append(" where @count>0 and ID=@ID;");
                  //console.log('add', sb.toString());
                }
                break;
              case "delevent":
                //select * from 表 where 条件;
                //delete from a where a=1 and b=2 and c=4 and (a=1 or b=2);select row_count() as count;
                //select row_count() as count;
                //或者是
                //set session group_concat_max_len=102400000;select group_concat('\'',ID,'\'') into @ID from ff_schedule where  `ID` = ifnull(?_ID,'');set @ID = ifnull(@ID,'NULL');SET @sql=concat('select * from ff_schedule  where ID in (',@ID,');');prepare co FROM @sql;execute co;SET @sql=concat('delete from ff_schedule  where ID in (',@ID,');');prepare co FROM @sql;execute co;select row_count() as count;DEALLOCATE PREPARE co;
                {
                  const where = that.getWhere(params, 2);
                  if (where.trim().eq("1=1"))
                    throw new Error("不能无条件删除所有数据!");
                  let _table = __.getTable(
                    database,
                    table.replace(/[<>]?\+/g, ","),
                    params,
                  );
                  sb.append("set session group_concat_max_len=102400000;");
                  sb.append(
                    "select group_concat('\\'',ID,'\\'') into @ID from (select ID from ",
                  )
                    .append(_table)
                    .append(" where ")
                    .append(where);
                  sb.append(
                    " ) a;set @ID = ifnull(@ID,'NULL');SET @sql=concat('select * from ",
                  )
                    .append(_table)
                    .append(
                      "  where ID in (',@ID,');');prepare co FROM @sql;execute co;",
                    );
                  sb.append("SET @sql=concat('delete from ")
                    .append(_table)
                    .append(
                      "  where ID in (',@ID,');');prepare co FROM @sql;execute co;select row_count() as count;DEALLOCATE PREPARE co;",
                    );
                  //console.log('del', sb.toString());
                }

                // {
                //     const where = that.getWhere(params, true);
                //     let _table = __.getTable(database, table.replace(/[<>]?\+/g, ','), params);
                //     sb.append("select * from ").append(_table).append(" where").append(where);
                //     sb.append(';delete ');
                //     if (table.match(/[<>]?\+|\,/g)) {
                //         var delindex = __.tindex.map(function (v) {
                //             return !!params[v] ? v : null;
                //         }).filter(function (v) { return !!v; }).join(',');
                //         if (!delindex) throw new Error('表连接未能说明需要删除的表 譬如a:true');
                //         sb.append(delindex);
                //     }
                //     sb.append(" from ").append(_table).append(" where ");
                //     if (where.trim().eq('1=1')) throw new Error('不能无条件删除所有数据!');
                //     sb.append(where).append(";select row_count() as count;");
                //     console.log('del', sb.toString());
                // }
                break;
              default:
                throw new Error("未识别的命令" + command);
            }
          }
          break;
        case 2:
          /**
           * 库名/操作
           * create 新建库
           * drop 删除库
           */
          {
            const database = cmds[0].replace(/^[~_\.]$/, ""),
              method = cmds[1];
            if (!database.length) throw new Error("请输入库名!");
            switch (method.toLowerCase()) {
              case "create":
                sb.append(
                  `create DATABASE if not exists ${database} CHARACTER SET utf8 COLLATE utf8_general_ci;select 1 as count;`,
                );
                break;
              case "drop":
                sb.append(
                  `DROP DATABASE IF EXISTS ${database};select 1 as count;`,
                );
                break;
              default:
                throw new Error("未识别的命令" + command);
            }
          }
          break;
        default:
          throw new Error(
            "无法处理命令类型:" +
              command +
              "!请按照[库].表[.字段|索引].操作 方式设置命令!",
          );
      }
      cmd.command = sb.clear();
      if ("true".eq(__.getValue(paraname["_debug"])))
        console.log("mysql", cmd.command, cmd.params);
    } finally {
      sb = null;
    }
  }
};

export default {
  EMBMySQLConverter,
};
const pri = V.pris();
